export default "__VITE_ASSET__DvIHaucX__"